import Constant from '@/common/constant/Constant';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';

import {
    getChildNameInDrillDown,
    getSystemFieldNameInDrillDown,
    isSelectedOption
} from '@/component/ticketKnowledge/handler/DrilldownAndDetailSearchHandler';
import { buildDrillDownSearchParam, sortListTagFieldByOrder, sortListTagFieldBySysField } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import { getHelpdeskListDrilldownData, getTicketHelpDeskList } from '@/service/ticketService';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import { I18n, Storage } from 'aws-amplify';
import { getDrilldownDataSelected } from './KnowledgeTicketHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaData } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { getUserListInProjectByProjectId } from '@/service/userService';

/**
 * openHelpdeskTicketListDrilldown
 * @param {*} argsCommon
 */
export const openHelpdeskTicketListDrilldown = argsCommon => {
    let panelType = Constant.PANEL_TYPE.HELPDESK_TICKET_LIST_DRILLDOWN_AND_DETAIL_SEARCH;

    argsCommon.addNewPanel({
        //update
        //type: Constant.PANEL_TYPE.ADD_TICKET,
        type: panelType,
        tabId: panelType,
        props: { ...argsCommon, componentName: 'DrilldownAndDetailSearch' },
        panelType,
        affiliationOrganization: argsCommon.corporationDetail.id,
        affiliationProject: argsCommon.projectInuseDetail.id,
        userDetail: argsCommon.userDetail
    });
};

export const getVisibleWidth = elements => {
    const container = document.getElementById('container');
    let containerRect = container.getBoundingClientRect();
    let eleRect = elements.getBoundingClientRect();
    let rect = {};
    rect.top = eleRect.top - containerRect.top;
    rect.right = eleRect.right - containerRect.right;
    rect.bottom = eleRect.bottom - containerRect.bottom;
    rect.left = eleRect.left - containerRect.left;
    rect.width = eleRect.width;

    return rect;
};

/**
 * removeDrillDownSelectedSearchTime
 * @param {*} argsCommon
 */
export const removeDrillDownSelectedSearchTime = argsCommon => {
    // update optionSearchTimeRange
    argsCommon.setOptionSearchTime('');

    // update structure
    let viewStructure = cloneDeep(argsCommon.viewStructure);
    let viewStructureOptions = cloneDeep(viewStructure.options);
    viewStructureOptions.from = null;
    viewStructureOptions.to = null;
    viewStructureOptions.searchDateAgoValue = 0;
    viewStructureOptions.searchDateAgoUnit = Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY;
    viewStructureOptions.searchDateType = Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.RANGE;
    viewStructure.options = viewStructureOptions;
    argsCommon.setViewStructure(viewStructure);

    // reload list ticket
    argsCommon.setTriggerSearch(Date.now().toString());
};

/**
 * getDrilldownHelpDeskWithPagination
 * @param {*} API 
 * @param {*} filterParams 
 * @param {*} drillDown 
 */
export const getDrilldownHelpDeskWithPagination = async (API, filterParams, drillDown = {}) => {
    let queryData = await getHelpdeskListDrilldownData(API, filterParams);
    let listData = Utils.convertJSONDataToObject(queryData?.data);
    let listDrillDown = listData;
    if (!Utils.isEmptyObject(drillDown)) {
        listDrillDown = mappingDrillDownHelpDesk(drillDown, listData);
    }
    if (listData?.sortLastValue?.length) {
        const newFilterParams = { ...filterParams, searchAfter: listData?.sortLastValue };
        listDrillDown = await getDrilldownHelpDeskWithPagination(
            API,
            newFilterParams,
            listDrillDown
        );
    }
    return listDrillDown;
};

/**
 * mappingDrillDown
 * @param {*} currentDrillDown 
 * @param {*} newDrillDown 
 * @returns 
 */
export const mappingDrillDownHelpDesk = (currentDrillDown, newDrillDown) => {
    if (!Utils.isEmptyObject(currentDrillDown) && !Utils.isEmptyObject(newDrillDown)) {
        for (const key of Object.keys(currentDrillDown)) {
            if (newDrillDown[key]['total']) {
                currentDrillDown[key]['total'] += newDrillDown[key]['total'];
            }
            switch (key) {
                case 'form':
                case Constant.DRILLDOWN_TYPE_TEXT.TICKET_TYPE:
                case 'projectOrigin':
                case 'projectTarget':
                case 'noticeTargetUser':
                case 'personInCharge':
                case 'creator':
                case 'updator':
                case 'proxiedUser': 
                case Constant.DRILLDOWN_TYPE_TEXT.TELEPHONE_EVALUATOR: {
                    const currentChildData = currentDrillDown[key];
                    const newChildData = newDrillDown[key];
                    for (const childKey of Object.keys(newChildData)) {
                        if (!currentChildData[childKey]) {
                            currentChildData[childKey] = newChildData[childKey]
                        }
                        if (currentChildData[childKey]) {
                            if (currentChildData[childKey]['count'] && newChildData[childKey]['count']) {
                                currentChildData[childKey]['count'] += newChildData[childKey]['count']
                            }
                        }
                    }
                    break;
                }
                case 'suffixOfAttachments': {
                    if (newDrillDown[key]['data']) {
                        if (!currentDrillDown[key]['data']) {
                            currentDrillDown[key]['data'] = newDrillDown[key]['data'];
                        } else {
                            for (const childKey of Object.keys(newDrillDown[key]['data'])) {
                                if (currentDrillDown[key]['data'][childKey]) {
                                    currentDrillDown[key]['data'][childKey] +=
                                        newDrillDown[key]['data'][childKey];
                                } else {
                                    currentDrillDown[key]['data'][childKey] =
                                        newDrillDown[key]['data'][childKey];
                                }
                            }
                        }
                    }
                    break;
                }
                case 'status':
                case 'tag': {
                    const currentChildData = currentDrillDown[key];
                    const newChildData = newDrillDown[key];
                    for (const childKey of Object.keys(newChildData)) {
                        if (!currentChildData[childKey]) {
                            currentChildData[childKey] = newChildData[childKey]
                        }
                        if (currentChildData[childKey]) {
                            if (currentChildData[childKey]['total'] && newChildData[childKey]['total']) {
                                currentChildData[childKey]['total'] += newChildData[childKey]['total']
                            }
                        }

                        if (
                            // key === 'status' &&
                            currentChildData[childKey]?.itemList &&
                            newChildData[childKey]?.itemList?.length
                        ) {
                            currentChildData[childKey].itemList = [
                                ...currentChildData[childKey].itemList,
                                ...newChildData[childKey]?.itemList
                            ];
                        }
                    }
                    break;
                }
                case 'liveOrArchived': {
                    if (newDrillDown[key]['data']) {
                        if (!currentDrillDown[key]['data']) {
                            currentDrillDown[key]['data'] = newDrillDown[key]['data'];
                        } else {
                            for (const childKey of Object.keys(newDrillDown[key]['data'])) {
                                if (currentDrillDown[key]['data'][childKey]) {
                                    currentDrillDown[key]['data'][childKey] +=
                                        newDrillDown[key]['data'][childKey];
                                } else {
                                    currentDrillDown[key]['data'][childKey] =
                                        newDrillDown[key]['data'][childKey];
                                }
                            }
                        }
                    }
                    break;
                }
                default:
                    break;
            }
        }
    }
    return currentDrillDown;
};

/**
 * get Drilldown Data And Sugguestion List
 * @param {*} argsCommon
 * @param {*} viewStructure
 * @returns
 */
export const getHelpdeskDrilldownDataAndSugguestionList = async (
    API,
    viewStructure,
    corporationId,
    projectId,
    userId,
    defaultDrillDownData,
    args = {}
) => {
    let filterParams = {
        corporationId: corporationId,
        projectId: projectId,
        userId: userId,
        visibility: viewStructure.visibility,
        viewStructure: viewStructure,
        formatSearch: '',
        from: args?.from || 0,
        size: args?.size || 2000
    };

    if (viewStructure.options?.otherFields) {
        let statusFieldData = defaultDrillDownData?.find(
            drilldown => drilldown.usage === Constant.DRILLDOWN_USAGE.STATUS
        );
        let formatSearch = viewStructure.options.otherFields;
        formatSearch = getFormatSearchFromStructrure(formatSearch, statusFieldData);
        filterParams.formatSearch = JSON.stringify(formatSearch);
    }

    if (args?.setCurrentSearchParams && typeof args?.setCurrentSearchParams === 'function') {
        args?.setCurrentSearchParams(filterParams);
    }
    let queryData = await getDrilldownHelpDeskWithPagination(API, filterParams);
    let listData = Utils.convertJSONDataToObject(queryData);

    let drilldownData = [];
    let arrCustomField = [];
    let arrCustomFieldTag = [];
    let arrCustomFieldStatus = [];
    let optionsList = [];

    let isDefault = Boolean(args?.isDefault);

    if (!Utils.isEmptyObject(listData)) {
        for (const [key, value] of Object.entries(listData)) {
            const hideInProject = Boolean(value?.hideInProject);
            // only display on suggestionList
            if (!isDefault && hideInProject) {
                continue;
            }
            delete value.hideInProject;
            if (!Utils.isEmptyObject(value)) {
                if (
                    [
                        Constant.DRILLDOWN_TYPE_TEXT.FORM,
                        Constant.DRILLDOWN_TYPE_TEXT.TICKET_TYPE,
                        Constant.DRILLDOWN_TYPE_TEXT.PROJECT_ORIGIN,
                        Constant.DRILLDOWN_TYPE_TEXT.PROJECT_TARGET,
                        Constant.DRILLDOWN_TYPE_TEXT.NOTICE_TARGET_USER,
                        Constant.DRILLDOWN_TYPE_TEXT.CREATOR,
                        Constant.DRILLDOWN_TYPE_TEXT.UPDATOR,
                        Constant.DRILLDOWN_TYPE_TEXT.EMAIL_TICKET_ORIGIN,
                        Constant.DRILLDOWN_TYPE_TEXT.PROXIED_USER,
                        Constant.DRILLDOWN_TYPE_TEXT.LIVE_OR_ARCHIVED,
                        Constant.DRILLDOWN_TYPE_TEXT.SUFFIX_OF_ATTACHMENTS,
                        Constant.DRILLDOWN_TYPE_TEXT.PERSON_IN_CHARGE,
                        Constant.DRILLDOWN_TYPE_TEXT.TELEPHONE_EVALUATOR,
                        Constant.DRILLDOWN_TYPE_TEXT.PRIVATE_BOOKMARK,
                        Constant.DRILLDOWN_TYPE_TEXT.SHARED_BOOKMARK,
                    ].includes(key) &&
                    value.total
                ) {
                    let child = [];
                    let childInOrg = [];
                    let childOutOrg = [];
                    let processData;
                    switch (key) {
                        case Constant.DRILLDOWN_TYPE_TEXT.FORM:
                            processData = processDrillDownDataForm(viewStructure, key, value);
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.TICKET_TYPE:
                            processData = processDrillDownDataTicketType(viewStructure, key, value);
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.PROJECT_ORIGIN:
                        case Constant.DRILLDOWN_TYPE_TEXT.PROJECT_TARGET:
                            processData = processDrillDownDataProject(viewStructure, key, value);
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.SUFFIX_OF_ATTACHMENTS:
                            processData = processDrillDownDataSuffixOfAttachments(
                                viewStructure,
                                key,
                                value
                            );
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.LIVE_OR_ARCHIVED:
                            processData = processDrillDownDataLiveOrArchived(
                                viewStructure,
                                key,
                                value
                            );
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.CREATOR:
                        case Constant.DRILLDOWN_TYPE_TEXT.UPDATOR:
                        case Constant.DRILLDOWN_TYPE_TEXT.PROXIED_USER:
                        case Constant.DRILLDOWN_TYPE_TEXT.PERSON_IN_CHARGE:
                        case Constant.DRILLDOWN_TYPE_TEXT.TELEPHONE_EVALUATOR:
                            processData = processDrillDownDataUser(viewStructure, key, value);
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.NOTICE_TARGET_USER:
                            processData = processDrillDownDataNoticeTargetUser(
                                viewStructure,
                                key,
                                value
                            );
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.EMAIL_TICKET_ORIGIN:
                            processData = processDrillDownDataEmailTicketOrigin(viewStructure, key, value);
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.PRIVATE_BOOKMARK:
                            processData = processDrillDownDataPrivateBookmark(viewStructure, key, value);
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.SHARED_BOOKMARK:
                            processData = processDrillDownDataSharedBookmark(viewStructure, key, value);
                            break;
                        default:
                            break;
                    }

                    child = processData.child || [];
                    optionsList = optionsList.concat(processData.optionsList);
                    childInOrg = processData.childInOrg || [];
                    childOutOrg = processData.childOutOrg || [];
                    drilldownData.push({
                        id: key,
                        label: getSystemFieldNameInDrillDown(key),
                        total: value.total,
                        usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                        child,
                        childInOrg,
                        childOutOrg,
                        isShowMore: false,
                        isShowMoreChildInOrg: false,
                        isShowMoreChildOutOrg: false,
                        orderInList: value.orderInList
                    });
                } else if (
                    [
                        Constant.FORMAT_OPTION_SEARCH.STATUS_FIELD,
                        Constant.FORMAT_OPTION_SEARCH.TAG_FIELD
                    ].includes(key)
                ) {
                    for (const [fieldId, fieldData] of Object.entries(value)) {
                        const hideFieldInProject = Boolean(fieldData?.data?.hideInProject ?? fieldData?.hideInProject)
                        if (!isDefault && hideFieldInProject) continue; // only display on suggestionList
                        delete fieldData.hideInProject;

                        if (fieldData.total && !Utils.isEmptyArray(fieldData.itemList)) {
                            let customFieldData = { ...fieldData, type: key };
                            if (key === Constant.FORMAT_OPTION_SEARCH.TAG_FIELD) {
                                arrCustomFieldTag.push(customFieldData);
                            } else if (key === Constant.FORMAT_OPTION_SEARCH.STATUS_FIELD) {
                                let newCustomFieldDataItemList = customFieldData.itemList.sort(
                                    (a, b) => {
                                        return a.data.sortIndex - b.data.sortIndex;
                                    }
                                );

                                customFieldData.itemList = newCustomFieldDataItemList.map(item => ({
                                    ...item,
                                    name: item?.data?.name,
                                    no: item?.data?.sortIndex
                                }));
                                arrCustomFieldStatus.push(customFieldData);
                            }
                        }
                    }
                }
            }
        }
    }

    // Sort custom field same type

    // Sort here
    arrCustomFieldTag = arrCustomFieldTag.sort((a, b) => {
        return new Date(b.data.createdAt) - new Date(a.data.createdAt);
    });
    arrCustomFieldStatus = arrCustomFieldStatus.sort((a, b) => {
        return new Date(b.data.createdAt) - new Date(a.data.createdAt);
    });
    // Arrange tag field order according to the order in the tag fields list
    arrCustomFieldTag = sortListTagFieldByOrder(arrCustomFieldTag);
    // Arrange the order of card systems before custom cards
    arrCustomFieldTag = sortListTagFieldBySysField(arrCustomFieldTag);

    arrCustomField = arrCustomFieldTag;

    // Process each status field independently - each field becomes a separate childStatusField
    if (!Utils.isEmptyArray(arrCustomFieldStatus)) {
        arrCustomFieldStatus.forEach((field, fieldIndex) => {
            if (!Utils.isEmptyArray(field.itemList)) {
                // Create a unique childStatusField for each status field
                let statusDummyId = `${Constant.DUMMY_DRILLDOWN_STATUS_ID}_${field.data?.id}`;
                let childStatusField = {
                    id: statusDummyId,
                    label: Utils.getTextByLanguage(
                        Constant.LANGUAGE_TYPE.JP,
                        field?.data?.name
                    ),
                    total: field.total,
                    usage: Constant.DRILLDOWN_USAGE.STATUS,
                    child: [],
                    orderInList: field?.data?.orderInList || Constant.ORDER_DEFAULT_LIST_FIELD,
                    hideInProject: field?.data?.hideInProject || false,
                };

                // Build child status items for this specific field
                let childStatus = [];
                field.itemList.forEach(item => {
                    let statusItemNumber = item?.data?.sortIndex;
                    let statusItemId = `${Constant.DUMMY_PREFIX_DRILLDOWN_STATUS_ITEM_ID}${statusItemNumber}`;

                    let indexInChildList = childStatus.findIndex(
                        statusItem => statusItem.id === statusItemId
                    );
                    
                    if (indexInChildList === -1) {
                        let statusItem = {};
                        statusItem.id = statusItemId;
                        statusItem.no = statusItemNumber;
                        statusItem.label = getStatusItemLabelByNo(
                            field.itemList,
                            statusItemNumber
                        );
                        statusItem.total = 1;
                        statusItem.listStatusId = [
                            {
                                fieldId: field.data?.id,
                                statusId: item.statusItemId
                            }
                        ];
                        childStatus.push(statusItem);
                    } else {
                        childStatus[indexInChildList].total += 1;
                        let fieldId = field.data?.id;
                        let statusItemIdSelect = item.statusItemId;
                        let isExistInItemList = childStatus[indexInChildList].listStatusId.find(
                            status =>
                                status.fieldId === fieldId && status.statusId === statusItemIdSelect
                        );
                        if (!isExistInItemList || Utils.isEmptyObject(isExistInItemList)) {
                            childStatus[indexInChildList].listStatusId.push({
                                fieldId: field.data?.id,
                                statusId: item.statusItemId
                            });
                        }
                    }
                });

                // Sort child status items by sortIndex
                childStatus = childStatus.sort((a, b) => {
                    return a.no - b.no;
                });

                // Assign sorted child status to field
                if (!Utils.isEmptyArray(childStatus)) {
                    childStatusField.child = childStatus;
                }

                // Add this field to drilldown data if it has tickets
                if (childStatusField.total && !Utils.isEmptyArray(childStatus)) {
                    drilldownData.push(childStatusField);

                    // Create options list for this specific field
                    let itemData = {
                        id: statusDummyId,
                        usage: Constant.DRILLDOWN_USAGE.STATUS
                    };
                    
                    childStatus.forEach(childField => {
                        if (!isSelectedOption(viewStructure, itemData, childField.id)) {
                            let ticketCount = '';
                            if (childField.total) {
                                ticketCount = `(${childField.total})`;
                            }
                            optionsList.push({
                                groupId: `${itemData.id}:${childField.id}`,
                                type: itemData.id,
                                id: `${childField.id}`,
                                label: `${childField.label}${ticketCount} ← ${childStatusField.label}`,
                                usage: itemData.usage,
                                labelForSearch: `${childField.label}`,
                                child: childStatus.find(child => child.id === childField.id)
                            });
                        }
                    });
                }
            }
        });
    }

    // Tag field
    if (!Utils.isEmptyArray(arrCustomField)) {
        let processDataTagFieldResult = processDrillDownDataTagField(arrCustomField, viewStructure, drilldownData, optionsList);
        drilldownData = processDataTagFieldResult.data;

        optionsList = processDataTagFieldResult.optionsList;
    };
    
    drilldownData = drilldownData.sort((a, b) => {
        return a.orderInList - b.orderInList;
    });
    return { drillDownData: drilldownData, sugguestionList: optionsList };
};

/**
 * processDrillDownDataTagField
 * @param {*} arrTagField 
 * @param {*} viewStructure 
 * @param {*} data 
 * @param {*} optionsList 
 */
export const processDrillDownDataTagField = (arrTagField, viewStructure, data, optionsList) => {
    if (Utils.isEmptyArray(arrTagField)) {
        return {
            data : !Utils.isEmptyArray(data) ? data : [],
            optionsList : !Utils.isEmptyArray(optionsList) ? optionsList : [],
        };
    };

    arrTagField.forEach(field => {
        let child = [];

        field.itemList.forEach(item => {

            let indexInChildList = Utils.findIndexInArrayById(item.data.id, child);
            if (indexInChildList === -1) {

                if (field.type === Constant.DRILLDOWN_USAGE.TAG.toLowerCase()) {
                    let tagItemType = field.tagItemType;
                    let tagItemLabel =
                        tagItemType === Constant.DRILLDOWN_TAG_ITEM_TYPE.MASTER_TAG_FIELD
                            ? item.data.name
                            : Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.data.name);

                    if (field?.data?.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER) {
                        tagItemLabel = item?.data?.name;
                    }
                   
                    child.push({
                        id: item.data.id,
                        label: tagItemLabel,
                        total: item.count,
                        hitNumber: item?.data?.hitNumber,
                        no: item?.data?.no,
                        firstImage: item?.data?.firstImage
                    });
                }
            } else {
                child[indexInChildList].total += 1;
            }
        });
        
        // Sort child
        child = Utils.sortByDrillDownLabelAsc(child);
        
        if (field.type === Constant.DRILLDOWN_USAGE.TAG.toLowerCase()) {
            switch (field.data.displayOrder) {
                // sort by order
                case Constant.DISPLAY_ORDER_TAG_FIELD.CUSTOMISE:
                    child.sort((item1, item2) => {
                        return item1.no - item2.no;
                    });
                    break;
                // sort by dictionary
                case Constant.DISPLAY_ORDER_TAG_FIELD.DICTIONARY_ORDER:
                    child = Utils.sortByDrillDownLabelAsc(child);
                    break;
                // sort by hits number order
                case Constant.DISPLAY_ORDER_TAG_FIELD.HITS_NUMBER_ORDER:
                    child.sort((item1, item2) => {
                        return item2.hitNumber - item1.hitNumber;
                    });
                    break;
                default:
                    child.sort((item1, item2) => {
                        return item1.no - item2.no;
                    });
                    break;
            }
        }

        data.push({
            id: field.data.id,
            label: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.data.name),
            total: field.total,
            usage: Constant.DRILLDOWN_USAGE.TAG,
            child,
            ticketItemData: field?.ticketItemData,
            sysField: field?.data?.sysField || '',
            orderInList: field.orderInList,
            isMultiple: field?.data?.isMultiple,
            optionType: field?.data?.optionType
        });

        if (!Utils.isEmptyArray(child)) {
            let itemData = {
                id: field.data.id,
                usage: Constant.DRILLDOWN_USAGE.TAG
            };
            child.forEach(childField => {
                if (!isSelectedOption(viewStructure, itemData, childField.id)) {
                    let ticketCount = '';
                    if (childField.total) {
                        ticketCount = `(${childField.total})`;
                    }
                    optionsList.push({
                        groupId: `${itemData.id}:${childField.id}`,
                        type: itemData.id,
                        id: `${childField.id}`,
                        label: `${childField.label}${ticketCount} ← ${Utils.getTextByLanguage(
                            Constant.LANGUAGE_TYPE.JP,
                            field.data.name
                        )}`,
                        usage: itemData.usage,
                        labelForSearch: `${childField.label}`
                    });
                }
            });
        }
    });

    return { data, optionsList };
}

/**
 * getStatusItemLabelByNo
 * @param {*} itemList
 * @param {*} no
 */
export const getStatusItemLabelByNo = (itemList, no) => {
    let label = '';
    if (!itemList || Utils.isEmptyArray(itemList) || !no) {
        return label;
    }
    
    let statusItemInfo = itemList.find(item => item?.no.toString() === no.toString());
    if (statusItemInfo && !Utils.isEmptyObject(statusItemInfo)) {
        label = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, statusItemInfo.name);
    }
    return label;
};

/**
 * processDrillDownDataForm
 * @param {*} viewStructure
 * @param {*} key
 * @param {*} value
 * @returns
 */
export const processDrillDownDataForm = (viewStructure, key, value) => {
    let optionsList = [];
    let child = [];
    let qaFormList = [];
    let noticeFormList = [];
    let systemFormList = [];
    let taskFormList = [];

    for (const [keyChild, valueChild] of Object.entries(value)) {
        if (keyChild && keyChild !== 'total' && keyChild !== Constant.ORDER_IN_LIST_FIELD_KEY) {
            let childLabel = getChildNameInDrillDown(key, valueChild.data);

            let childData = {
                id: keyChild,
                label: childLabel,
                total: valueChild.count,
                createdAt: valueChild.data.createdAt
            };

            if (
                valueChild.data.type === Constant.FORM_TYPE.FORM_REQ_QA ||
                valueChild.data.type === Constant.FORM_TYPE.FORM_REQ
            ) {
                qaFormList.push(childData);
            }
            if (valueChild.data.type === Constant.FORM_TYPE.FORM_REQ_NOTICE) {
                noticeFormList.push(childData);
            }
            if (
                valueChild.data.definition === Constant.FORM_DEFINITION.SYSTEM &&
                valueChild.data.type !== Constant.FORM_TYPE.FORM_REQ_QA
            ) {
                systemFormList.push(childData);
            }
            if (valueChild.data.type === Constant.FORM_TYPE.FORM_TASK) {
                taskFormList.push(childData);
            }

            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };
            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild.count) {
                    ticketCount = `(${valueChild.count})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${childLabel}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${childLabel}`
                });
            }
        }
    }

    // Sort list form
    // qaFormList = Utils.sortByCreatedAtDesc(qaFormList);
    // noticeFormList = Utils.sortByCreatedAtDesc(noticeFormList);
    // systemFormList = Utils.sortByCreatedAtDesc(systemFormList);
    // taskFormList = Utils.sortByCreatedAtDesc(taskFormList);

    child = qaFormList.concat(noticeFormList, systemFormList, taskFormList);
    child = sortFormInDrilldown(child);
    return { child, optionsList };
};

/**
 * sortFormInDrilldown
 * sort by total value
 * if total equal, sort createdAt desc
 * @param {*} formList 
 * @returns 
 */
export const sortFormInDrilldown = formList => {
    if (Utils.isEmptyArray(formList)) return [];

    return formList.sort((a, b) => {
        if (a.total !== b.total) {
            return b.total - a.total;
        } else {
            return new Date(b.createdAt) - new Date(a.createdAt);
        }
    });
};

/**
 * processDrillDownDataSuffixOfAttachments
 * @param {*} viewStructure
 * @param {*} key
 * @param {*} value
 * @returns
 */
export const processDrillDownDataSuffixOfAttachments = (viewStructure, key, value) => {
    let suffixData = value.data;
    let child = [];
    let optionsList = [];

    for (const [keyChildSuffix, valueChildSuffix] of Object.entries(suffixData)) {
        child.push({
            id: keyChildSuffix,
            label: `${keyChildSuffix}`,
            total: valueChildSuffix
        });

        let itemData = {
            id: key,
            usage: Constant.DRILLDOWN_USAGE.SYSTEM
        };
        if (!isSelectedOption(viewStructure, itemData, keyChildSuffix)) {
            let ticketCount = '';
            if (valueChildSuffix) {
                ticketCount = `(${valueChildSuffix})`;
            }
            optionsList.push({
                groupId: `${key}:${keyChildSuffix}`,
                type: key,
                id: `${keyChildSuffix}`,
                label: `${keyChildSuffix}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                labelForSearch: `${keyChildSuffix}`
            });
        }
    }

    child = Utils.sortByDrillDownLabelAsc(child);
    optionsList = Utils.sortByDrillDownLabelAsc(optionsList);

    return { child, optionsList };
};

/**
 * processDrillDownDataLiveOrArchived
 * @param {*} viewStructure
 * @param {*} key
 * @param {*} value
 */
export const processDrillDownDataLiveOrArchived = (viewStructure, key, value) => {
    let data = value.data;
    let child = [];
    let optionsList = [];

    for (const [keyChild, valueChild] of Object.entries(data)) {
        if (valueChild) {
            child.push({
                id: keyChild,
                label: getLiveOrArchivedNameInDrillDown(keyChild),
                total: valueChild
            });

            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };
            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild) {
                    ticketCount = `(${valueChild})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${getLiveOrArchivedNameInDrillDown(
                        keyChild
                    )}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${getLiveOrArchivedNameInDrillDown(keyChild)}`
                });
            }
        }
    }

    return { child, optionsList };
};

/**
 * processDrillDownDataUser
 * @param {*} viewStructure
 * @param {*} key
 * @param {*} value
 * @returns
 */
export const processDrillDownDataUser = (viewStructure, key, value) => {
    let child = [];
    let optionsList = [];

    for (const [keyChild, valueChild] of Object.entries(value)) {
        if (keyChild && keyChild !== 'total' && keyChild !== Constant.ORDER_IN_LIST_FIELD_KEY) {
            let childLabel = '';

            if (keyChild === Constant.ANONYMOUS_USER_ID) {
                childLabel = I18n.get('USER04LB052');
            } else {
                childLabel = getChildNameInDrillDown(key, valueChild.data);
            }

            child.push({
                id: keyChild,
                label: childLabel,
                total: valueChild.count
            });

            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };
            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild.count) {
                    ticketCount = `(${valueChild.count})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${childLabel}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${childLabel}`
                });
            }
        }
    }

    child = Utils.sortByDrillDownLabelAsc(child);
    optionsList = Utils.sortByDrillDownLabelAsc(optionsList);

    return { child, optionsList };
};

export const processDrillDownDataEmailTicketOrigin = (viewStructure, key, value) => {
    let child = [];
    let optionsList = [];

    for (const [keyChild, valueChild] of Object.entries(value)) {
        if (keyChild && keyChild !== 'total' && keyChild !== Constant.ORDER_IN_LIST_FIELD_KEY) {
            let childLabel = '';

            if (keyChild === Constant.DRILLDOWN_TYPE.EMAIL_TICKET_SDESK_SEND) {
                childLabel = I18n.get('EMAIL_TICKET_SDESK_SEND_DRILLDOWN_TEXT');
            } else if (keyChild === Constant.DRILLDOWN_TYPE.EMAIL_TICKET_SDESK_RECEIVE) {
                childLabel = I18n.get('EMAIL_TICKET_SDESK_RECEIVE_DRILLDOWN_TEXT');
            }

            child.push({
                id: keyChild,
                label: childLabel,
                total: valueChild.count
            });

            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };
            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild.count) {
                    ticketCount = `(${valueChild.count})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${childLabel}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${childLabel}`
                });
            }
        }
    }

    child = Utils.sortByDrillDownLabelAsc(child);
    optionsList = Utils.sortByDrillDownLabelAsc(optionsList);

    return { child, optionsList };
};

/**
 * processDrillDownDataPrivateBookmark
 * @param {*} viewStructure 
 * @param {*} key 
 * @param {*} value 
 * @returns 
 */
const processDrillDownDataPrivateBookmark = (viewStructure, key, value) => {
    let child = [];
    let optionsList = [];

    for (const [keyChild, valueChild] of Object.entries(value)) {
        if (keyChild && keyChild !== 'total' && keyChild !== Constant.ORDER_IN_LIST_FIELD_KEY) {
            let dataOfBookMark = valueChild.data;
            let childLabel = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,dataOfBookMark.name);

            child.push({
                id: keyChild,
                label: childLabel,
                total: valueChild.count,
            });
            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };
            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild.count) {
                    ticketCount = `(${valueChild.count})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${childLabel}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${childLabel}${getSystemFieldNameInDrillDown(key)}`,
                    nameOfChild: childLabel
                });
            }
        }
    }

    
    if(!Utils.isEmptyArray(child)){
        child = Utils.sortByDrillDownLabelAsc(child)
    };

    if(!Utils.isEmptyArray(optionsList)){
        optionsList = Utils.sortByDrillDownLabelAsc(optionsList)
    };

    return { child, optionsList };
};

/**
 * processDrillDownDataPrivateBookmark
 * @param {*} viewStructure 
 * @param {*} key 
 * @param {*} value 
 * @returns 
 */
const processDrillDownDataSharedBookmark = (viewStructure, key, value) => {
    let child = [];
    let optionsList = [];

    for (const [keyChild, valueChild] of Object.entries(value)) {
        if (keyChild && keyChild !== 'total' && keyChild !== Constant.ORDER_IN_LIST_FIELD_KEY) {
            
            let dataOfBookMark = valueChild.data;
            let childLabel = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,dataOfBookMark.name);

            child.push({
                id: keyChild,
                label: childLabel,
                total: valueChild.count,
            });

            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };

            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild.count) {
                    ticketCount = `(${valueChild.count})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${childLabel}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${childLabel}${getSystemFieldNameInDrillDown(key)}`,
                    nameOfChild: childLabel
                });
            }
        }
    }

    if(!Utils.isEmptyArray(child)){
        child = Utils.sortByDrillDownLabelAsc(child)
    };

    if(!Utils.isEmptyArray(optionsList)){
        optionsList = Utils.sortByDrillDownLabelAsc(optionsList)
    };

    return { child, optionsList };
};

/**
 * processDrillDownDataProject
 * @param {*} viewStructure
 * @param {*} key
 * @param {*} value
 * @returns
 */
export const processDrillDownDataProject = (viewStructure, key, value) => {
    let currentCorporationId = localStorageUtil.getAffiliationOrganization();
    let childInOrg = [];
    let childOutOrg = [];
    let optionsList = [];

    for (const [keyChild, valueChild] of Object.entries(value)) {
        if (keyChild && keyChild !== 'total' && keyChild !== Constant.ORDER_IN_LIST_FIELD_KEY) {
            let projectName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                valueChild.data.name
            );
            let childLabel = '';

            let childData = {
                id: keyChild,
                total: valueChild.count,
                name: valueChild.data.name
            };

            if (valueChild.data.affiliationOrganization === currentCorporationId) {
                childLabel = projectName;
                childData.label = childLabel;
                childInOrg.push(childData);
            } else {
                let corporationName = Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    valueChild.data.corporationName
                );
                if (valueChild.data.corporationActive) {
                    let objCorporation = {
                        active: valueChild.data.corporationActive
                    };
                    let corporationNameSuffixText = Utils.getCorporationNameSuffixText(
                        objCorporation
                    );
                    if (corporationNameSuffixText) {
                        corporationName = `${corporationName} (${corporationNameSuffixText})`;
                    }
                }
                childLabel = `${projectName} (${corporationName})`;
                childData.label = childLabel;
                childOutOrg.push(childData);
            }

            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };
            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild.count) {
                    ticketCount = `(${valueChild.count})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${childLabel}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${childLabel}`
                });
            }
        }
    }

    // Resort childInOrg, childOutOrg
    // childInOrg = sortFieldListByDictionary(childInOrg);
    // childOutOrg = sortFieldListByDictionary(childOutOrg);
    childInOrg = Utils.sortByDrillDownLabelAsc(childInOrg);
    childOutOrg = Utils.sortByDrillDownLabelAsc(childOutOrg);
    optionsList = Utils.sortByDrillDownLabelAsc(optionsList);
    return { childInOrg, childOutOrg, optionsList };
};

export const processDrillDownDataNoticeTargetUser = (viewStructure, key, value) => {
    let childInOrg = [];
    let childOutOrg = [];
    let optionsList = [];

    for (const [keyChild, valueChild] of Object.entries(value)) {
        if (keyChild && keyChild !== 'total' && keyChild !== Constant.ORDER_IN_LIST_FIELD_KEY ) {
            let childLabel = getChildNameInDrillDown(key, valueChild.data);

            let childData = {
                id: keyChild,
                total: valueChild.count,
                name: valueChild.data.name,
                childLabel,
                label: childLabel
            };
            if (
                Constant.USER_TYPE.CUSTOMER !== valueChild.data.type &&
                !Utils.isGuestUser(valueChild.data)
            ) {
                childInOrg.push(childData);
            } else {
                childOutOrg.push(childData);
            }

            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };
            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild.count) {
                    ticketCount = `(${valueChild.count})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${childLabel}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${childLabel}`
                });
            }
        }
    }

    // Resort childInOrg, childOutOrg
    // childInOrg = sortFieldListByDictionary(childInOrg);
    // childOutOrg = sortFieldListByDictionary(childOutOrg);
    childInOrg = Utils.sortByDrillDownLabelAsc(childInOrg);
    childOutOrg = Utils.sortByDrillDownLabelAsc(childOutOrg);
    optionsList = Utils.sortByDrillDownLabelAsc(optionsList);

    return { childInOrg, childOutOrg, optionsList };
};

/**
 * getLiveOrArchivedNameInDrillDown
 * @param {*} type
 * @returns
 */
export const getLiveOrArchivedNameInDrillDown = type => {
    let name = '';

    switch (type) {
        case Constant.LIVE_OR_ARCHIVED.LIVE:
            name = 'Active';
            break;
        case Constant.LIVE_OR_ARCHIVED.ARCHIVED:
            name = 'Archived';
            break;
        default:
            break;
    }

    return name;
};

/**
 * onKeyPressSearchKeyWord
 * @param {*} e
 * @param {*} argsCommon
 * @returns
 */
export const onKeyPressSearchKeyWord = async (e, argsCommon) => {
    if (e.key !== 'Enter') {
        return;
    }

    onSubmitSearchTicketList(argsCommon);
};

/**
 * onSubmitSearchTicketList
 * @param {*} argsCommon
 */
export const onSubmitSearchTicketList = argsCommon => {
    let currentViewStructure = cloneDeep(argsCommon.viewStructure);
    if (currentViewStructure.keyword === argsCommon.keywordSearch) {
        argsCommon.setTriggerSearch(Date.now().toString());
    } else {
        currentViewStructure.keyword = argsCommon.keywordSearch;
        argsCommon.setViewStructure(currentViewStructure);
    }

    if (argsCommon.lastUserAction !== LogKibanaConstant.SEARCH_ACTION.KEY_WORD) {
        argsCommon.setLastUserAction(LogKibanaConstant.SEARCH_ACTION.KEY_WORD);
    }
};

export const handleSearchTicketList = async (
    API,
    setTotalTickets,
    corporationId,
    projectId,
    userId,
    viewStructure,
    setViewStructure,
    setOptionSearchTime,
    defaultDrillDownData,
    inputKeyWordRef,
    visibility,
    from = 0,
    size = Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD,
    lastUserAction = null,
    corporationDetail,
    projectInuseDetail,
    userDetail,
    searchContentType,
    searchTagSuggest,
    searchContainAny,
    searchNotInclude,
    viewSelected,
    removedTagItem,
    setRemovedTagItem,
    setSearchTagSuggest
) => {
    if (!visibility) return;
    let drillDownSearch = buildDrillDownSearchParam(viewStructure);

    let keywordSearch = '';
    // Replace JP space
    if (viewStructure?.keyword) {
        keywordSearch = viewStructure?.keyword.trim();
        if (keywordSearch) {
            keywordSearch = keywordSearch?.toString().replace(/\s+/g, ' ');
        }
    }

    let normalizedKeywordSearch = keywordSearch ? keywordSearch : '';
    let keywordList = normalizedKeywordSearch ? normalizedKeywordSearch.split(' ') : [];
    keywordList = keywordList.map(keyword => Utils.normarlizeSearchKeyword(keyword));

    // optionSearch (keyword, method(AND/OR), target search(outline,...),....)
    let optionSearch = {
        methodSearch: viewStructure?.options?.method
            ? viewStructure?.options?.method
            : Constant.SETTING_SEARCH_KEYWORD.AND,
        attributeSearch: viewStructure?.options?.attribute
            ? viewStructure?.options?.attribute
            : Constant.SETTING_SEARCH_KEYWORD.MUTIPLE,
        keywordList,
        // keywordList: keywordSearch ? keywordSearch.split(' ') : [],
        formatSearch: '',
        isSearchSynonym: !!viewStructure?.options?.isSearchSynonym
    };

    // Search by date / time
    let fromSearchDate;
    let toSearchDate;

    let optionSearchTime = '';
    let agoUnit = ''
    if (viewStructure.options?.searchDateType === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO) {
        agoUnit = viewStructure.options?.searchDateAgoUnit
            ? viewStructure.options?.searchDateAgoUnit
            : Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY;
        let agoValue = viewStructure.options?.searchDateAgoValue
            ? viewStructure.options?.searchDateAgoValue
            : 0;
        let agoUnitTime =
            agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK
                ? 7 * 24 * 60 * 60 * 1000
                : 24 * 60 * 60 * 1000;

        // toSearchDate is today
        toSearchDate = moment(new Date()).format('YYYY/MM/DD');

        // 0 days ago
        if (!agoValue && agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY) {
            fromSearchDate = toSearchDate;
            optionSearchTime = `投稿日：最近 0 日間`;
        } else if (!agoValue && agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK) {
            // 0 week ago = monday - today
            fromSearchDate = moment()
                .startOf('isoweek')
                .format('YYYY/MM/DD');
            optionSearchTime = `投稿日：最近 0 週間`;
        } else {
            fromSearchDate = moment(new Date() - agoValue * agoUnitTime).format('YYYY/MM/DD');
            optionSearchTime =
                agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK
                    ? `投稿日：最近 ${agoValue} 週間`
                    : `投稿日：最近 ${agoValue} 日間`;
        }

        optionSearch.fromSearchDate = fromSearchDate;
        optionSearch.toSearchDate = toSearchDate;
    } else {
        if (viewStructure.options?.from) {
            fromSearchDate = viewStructure.options.from;
            optionSearch.fromSearchDate = viewStructure.options.from;
        }

        if (viewStructure.options?.to) {
            toSearchDate = viewStructure.options.to;
            optionSearch.toSearchDate = viewStructure.options.to;
        }

        if (fromSearchDate && toSearchDate && fromSearchDate > toSearchDate) {
            // switch search date
            let newFromSearchDate = toSearchDate;
            let newToSearchDate = fromSearchDate;

            fromSearchDate = newFromSearchDate;
            toSearchDate = newToSearchDate;

            optionSearch.fromSearchDate = fromSearchDate;
            optionSearch.toSearchDate = toSearchDate;

            let currentViewStructure = cloneDeep(viewStructure);
            currentViewStructure.options.from = fromSearchDate;
            currentViewStructure.options.to = toSearchDate;
            setViewStructure(currentViewStructure);
        }

        if (fromSearchDate || toSearchDate) {
            optionSearchTime = `投稿日：${fromSearchDate || ''} ～ ${toSearchDate || ''}`;
        }
    }

    // Set state optionSearchTimeAgo / optionSearchTimeRange
    setOptionSearchTime(optionSearchTime);

    if (viewStructure.options?.otherFields) {
        let statusFieldData = defaultDrillDownData?.find(
            drilldown => drilldown.usage === Constant.DRILLDOWN_USAGE.STATUS
        );
        let formatSearch = viewStructure.options.otherFields;
        formatSearch = getFormatSearchFromStructrure(formatSearch, statusFieldData);
        optionSearch.formatSearch = JSON.stringify(formatSearch);
    }

    // Sort
    optionSearch.sortType = viewStructure.options['sort']
        ? viewStructure.options['sort']
        : Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;

    // Outfocus keyword input
    inputKeyWordRef.current.blur();

    let publicTicket = '';
    let ticketProperty = '';
    switch (viewStructure.ticketProperty) {
        case Constant.TICKET_PROPERTY.SENT:
            drillDownSearch.liveOrArchived = Constant.LIVE_OR_ARCHIVED.LIVE;
            publicTicket = Constant.TICKET_PUBLIC.PUBLIC;
            ticketProperty = Constant.TICKET_PROPERTY.SENT;
            break;
        case Constant.TICKET_PROPERTY.DRAFT:
            drillDownSearch.liveOrArchived = Constant.LIVE_OR_ARCHIVED.LIVE;
            publicTicket = Constant.TICKET_PUBLIC.DRAFT;
            ticketProperty = Constant.TICKET_PROPERTY.DRAFT;
            break;
        case Constant.TICKET_PROPERTY.ARCHIVE:
            drillDownSearch.liveOrArchived = Constant.LIVE_OR_ARCHIVED.ARCHIVED;
            publicTicket = Constant.TICKET_PUBLIC.PUBLIC;
            ticketProperty = Constant.TICKET_PROPERTY.ARCHIVE;
            break;
        case Constant.TICKET_PROPERTY.DELETE:
            ticketProperty = Constant.TICKET_PROPERTY.DELETE;
            break;
        case Constant.TICKET_PROPERTY.TRAINING:
            drillDownSearch.liveOrArchived = Constant.LIVE_OR_ARCHIVED.LIVE;
            publicTicket = Constant.TICKET_PUBLIC.PUBLIC;
            ticketProperty = Constant.TICKET_PROPERTY.TRAINING;
            break;
        default:
            break;
    }

    let filterInput = {
        visibilitySettingType: visibility,
        affiliationOrganization: corporationId,
        affiliationProject: projectId,
        userId: userId,
        drillDownSearch: drillDownSearch,
        optionSearch,
        public: publicTicket,
        ticketProperty: ticketProperty,
        from: from,
        size: size || Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD
    };


    //create data log for write log to Kibana
    if (lastUserAction) {
        let operationScreen = LogKibanaConstant.OPERATION_SCREEN.SOLUTION_DESK;
        let dateUnit = '';
        if (agoUnit) {
            dateUnit = agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK ? LogKibanaConstant.DATE_UNIT.WEEK : LogKibanaConstant.DATE_UNIT.DAY;
        }

        let kibanaSortType = LogKibanaConstant.SORT_TYPE.CREATED_AT;
        switch (optionSearch.sortType) {
            case Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT:
                kibanaSortType = LogKibanaConstant.SORT_TYPE.UPDATED_AT;
                break;
            case Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.SORT_TOTAL_PRIVATE_BOOKMARK_ASC:
                kibanaSortType = LogKibanaConstant.SORT_TYPE.PRIVATE_BOOKMARK_ASC;
                break;
            case Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.SORT_TOTAL_PRIVATE_BOOKMARK_DESC:
                kibanaSortType = LogKibanaConstant.SORT_TYPE.PRIVATE_BOOKMARK_DESC;
                break;
            default:
                break;
        }

        let inforSearch = {
            // data drill down
            searchDateType: viewStructure.options?.searchDateType || Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.RANGE,
            fromSearchDate: optionSearch.fromSearchDate,
            toSearchDate: optionSearch.toSearchDate,
            searchDateAgoValue: viewStructure.options?.searchDateAgoValue,
            searchDateAgoUnit: dateUnit,
            searchContainAny: searchContainAny,
            searchNotInclude: searchNotInclude,
            sortType: kibanaSortType,
    
            // data for view change
            viewName: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, viewSelected.name),
            viewId: viewSelected.id,
            viewKeyword: keywordList,
            viewKeywordCondition: optionSearch.methodSearch,
            viewSearchTarget: optionSearch.attributeSearch === Constant.SETTING_SEARCH_KEYWORD.MUTIPLE ? LogKibanaConstant.SEARCH_TARGET.BODY : LogKibanaConstant.SEARCH_TARGET.CHAT,
            viewDateType: viewStructure.options?.searchDateType || Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.RANGE,
            viewDateFrom: optionSearch.fromSearchDate,
            viewDateTo: optionSearch.toSearchDate,
            viewDateTerm: viewStructure.options?.searchDateAgoValue,
            viewDateUnit: dateUnit,
            viewOrTag: searchContainAny,// get on server
            viewExceptTag: searchNotInclude,// get on server
            viewTag: searchTagSuggest, // get on server
            viewSort: kibanaSortType,
        }
        if (inforSearch.searchDateType === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO) {
            let dateTerm = viewStructure.options?.searchDateAgoValue || 0;
            inforSearch.searchDateAgoValue = dateTerm;
            inforSearch.viewDateTerm = dateTerm;
        }

        let logKibanaData;
        if(lastUserAction === LogKibanaConstant.SEARCH_ACTION.TAG_REMOVE && !Utils.isEmptyObject(removedTagItem) ) {
            let tagRemove = `${removedTagItem.tagName}@${removedTagItem.fieldName}`
            let newListTagSuggest = [];
            if (!Utils.isEmptyArray(searchTagSuggest)) {
                for (const tagSuggest of searchTagSuggest) {
                    if (tagRemove !== tagSuggest) {
                        newListTagSuggest.push(tagSuggest);
                    }
                }
            }
            inforSearch.viewTag = newListTagSuggest;
            setSearchTagSuggest(newListTagSuggest);
            logKibanaData = createKibanaData(lastUserAction, filterInput, keywordList, corporationDetail, projectInuseDetail, userDetail, searchContentType, operationScreen, newListTagSuggest, inforSearch, removedTagItem);
            
            //clear state click remove tag
            setRemovedTagItem({})
        }else {
            logKibanaData = createKibanaData(lastUserAction, filterInput, keywordList, corporationDetail, projectInuseDetail, userDetail, searchContentType, operationScreen, searchTagSuggest, inforSearch);
        }
        
        if(!Utils.isEmptyObject(logKibanaData)) filterInput.logKibanaData = JSON.stringify(logKibanaData);

    }

    // call api search ticket knowledge
    let resultTicketHelpDeskList = await getTicketHelpDeskList(API, filterInput);
    let dataList = resultTicketHelpDeskList.ticketHelpDeskList;
    let totalTickets = resultTicketHelpDeskList.totalTickets;
    setTotalTickets(totalTickets);
    if (ticketProperty === Constant.TICKET_PROPERTY.DELETE) {
        dataList = Utils.sortByDeletedAtAsc(dataList);
    }
    
    return dataList;
};

export const onScrollHelpdeskTicketList = async (event, argsCommon) => {
    let element = event.target;

    let {
        API,
        corporationId,
        projectId,
        userId,
        viewStructure,
        setViewStructure,
        setOptionSearchTime,
        defaultDrillDownData,
        inputKeyWordRef,
        lastedCountList,
        setLastedCountList,
        fromTicket,
        setFromTicket,
        setIsLoading,
        keywordSearch,
        setKeywordSearch,
        ticketList,
        setTicketList,
        setTotalTickets
    } = argsCommon;

    if (
        element.offsetHeight + element.scrollTop >= element.scrollHeight &&
        lastedCountList === Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD
    ) {
        let from = fromTicket + Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD;
        setIsLoading(true);
        handleSearchTicketList(
            API,
            setTotalTickets,
            corporationId,
            projectId,
            userId,
            viewStructure,
            setViewStructure,
            setOptionSearchTime,
            defaultDrillDownData,
            inputKeyWordRef,
            viewStructure.visibility,
            from
        )
            .then(async ticketListResult => {
                setLastedCountList(ticketListResult.length);
                setFromTicket(from);

                // Update keyword search
                if (viewStructure.keyword !== keywordSearch) {
                    setKeywordSearch(viewStructure.keyword);
                }

                let allTicketList = ticketList?.concat(ticketListResult);
                setTicketList(allTicketList);
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
            });
    }
};

export const autoReloadTicketList = async argsCommon => {
    let {
        API,
        corporationId,
        projectId,
        userId,
        viewStructure,
        setViewStructure,
        setOptionSearchTime,
        defaultDrillDownData,
        inputKeyWordRef,
        keywordSearch,
        setKeywordSearch,
        ticketList,
        setTicketList,
        setDrillDownDataSelected,
        setDrillDownData,
        setSugguestionList,
        setDefaultDrillDownData,
        userListRecoilValue,
        setProjectUserList,
        setTotalTickets,
        setIsLoading
    } = argsCommon;
    setIsLoading(true);
    let size =
        ticketList?.length > Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD
            ? ticketList?.length
            : Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD;

    handleSearchTicketList(
        API,
        setTotalTickets,
        corporationId,
        projectId,
        userId,
        viewStructure,
        setViewStructure,
        setOptionSearchTime,
        defaultDrillDownData,
        inputKeyWordRef,
        viewStructure.visibility,
        0,
        size
    ).then(async ticketListResult => {
        // Update keyword search
        if (viewStructure.keyword !== keywordSearch) {
            setKeywordSearch(viewStructure.keyword);
        }

        setTicketList(ticketListResult);

        // Get default drilldown data for list option include/exclude
        let defaultViewStructure = cloneDeep(Constant.DEFAULT_VIEW_STRUCTURE);
        defaultViewStructure.visibility = viewStructure.visibility;
        defaultViewStructure.ticketProperty = viewStructure.ticketProperty
            ? viewStructure.ticketProperty
            : '';
        let [_drilldownSelected, _memberListAssign, drillDownDataResult] = await Promise.all([
            getDrilldownDataSelected(API, viewStructure, setDrillDownDataSelected, true, false),
            getProjectMemberList(userListRecoilValue, setProjectUserList),
            
            getHelpdeskDrilldownDataAndSugguestionList(
                API,
                viewStructure,
                corporationId,
                projectId,
                userId,
                defaultDrillDownData,
            )
        ]);

        setDrillDownData(drillDownDataResult.drillDownData);
        setSugguestionList(drillDownDataResult.sugguestionList);
        
        setIsLoading(false);

        let resDefaultDrillDownData = await getHelpdeskDrilldownDataAndSugguestionList(
            API,
            defaultViewStructure,
            corporationId,
            projectId,
            userId,
            defaultDrillDownData,
            {isDefault: true}
        )
        setDefaultDrillDownData(resDefaultDrillDownData.drillDownData);
    });
};

/**
 * getFormatSearchFromStructrure
 * @param {*} formatSearch
 * @param {*} statusFieldData
 * @returns
 */
export const getFormatSearchFromStructrure = (formatSearch, statusFieldData) => {
    let newFormatSearch = cloneDeep(formatSearch);
    if (!Utils.isEmptyArray(formatSearch.include)) {
        newFormatSearch.include = convertIncludeAndExcludeFieldStatus(
            formatSearch.include,
            statusFieldData
        );
    }
    if (!Utils.isEmptyArray(formatSearch.exclude)) {
        newFormatSearch.exclude = convertIncludeAndExcludeFieldStatus(
            formatSearch.exclude,
            statusFieldData
        );
    }
    return newFormatSearch;
};

/**
 * convertIncludeAndExcludeFieldStatus
 * @param {*} initList
 * @param {*} statusFieldData
 * @returns
 */
export const convertIncludeAndExcludeFieldStatus = (initList, statusFieldData) => {
    let newIncludeOrExclude = [];

    if (!Utils.isEmptyArray(initList)) {
        initList.forEach(includeItem => {
            if (includeItem.type === Constant.FORMAT_OPTION_SEARCH.STATUS_FIELD) {
                let includeStatusValue = includeItem.value[0];
                if (includeStatusValue) {
                    const [statusFieldId, statusItemId] = includeStatusValue.split(':');
                    if (
                        !Utils.isEmptyObject(statusFieldData) &&
                        statusFieldData.id === statusFieldId &&
                        !Utils.isEmptyArray(statusFieldData.child)
                    ) {
                        let statusItemListId = statusFieldData.child.find(
                            statusItemData => statusItemData.id === statusItemId
                        );
                        if (
                            statusItemListId &&
                            statusItemListId.listStatusId &&
                            !Utils.isEmptyArray(statusItemListId.listStatusId)
                        ) {
                            statusItemListId.listStatusId.forEach(listStatusItem => {
                                newIncludeOrExclude.push({
                                    type: Constant.FORMAT_OPTION_SEARCH.STATUS_FIELD,
                                    value: [`${listStatusItem.fieldId}:${listStatusItem.statusId}`]
                                });
                            });
                        }
                    }
                }
            } else {
                newIncludeOrExclude.push(includeItem);
            }
        });
    }
    return newIncludeOrExclude;
};

/**
 * getProjectMemberList
 * @param {*} argsCommon
 */
export const getProjectMemberList = async (
    userListRecoilValue = [],
    setProjectUserList = () => {},
    projectId = ''
) => {
    let userListOfProject = cloneDeep(userListRecoilValue) || [];
    if (Utils.isEmptyArray(userListOfProject)) {
        if (!projectId) {
            projectId = localStorageUtil.getSelectedProjectId();
        }

        userListOfProject = await getUserListInProjectByProjectId(null, projectId);
    }
    let memberList = userListOfProject.filter(user => user.type !== Constant.USER_TYPE.CUSTOMER);

    if (!Utils.isEmptyArray(memberList)) {
        await Promise.all([
            memberList.map(async member => {
                if (member.image) {
                    member.avatar = await Storage.get(member.image);
                } else {
                    member.avatar = '';
                }
                member.fullName = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, member);
                member.mail = Utils.getDisplayUserEmailWithoutSuffix(member.mail);

                // delete some properties not use
                delete member?.settingNotification;
                delete member?.workSpace;
                return member;
            })
        ]);
    }

    let sortedMemberList = sortListByDictionaryASC(memberList);
    if (setProjectUserList) {
        setProjectUserList(sortedMemberList);
    }
    return sortedMemberList;
};

/**
 * sort list user by alphabetical order
 * @param {*} list Object
 */
export const sortListByDictionaryASC = list => {
    if (Utils.isEmptyArray(list)) {
        return [];
    }
    return list.sort((a, b) => {
        let nameA = a.fullName ? a.fullName : Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, a);
        let nameB = b.fullName ? b.fullName : Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, b);
        return nameA.localeCompare(nameB);
    });
};

export const handleOnChangeSearchSynonym = (checked, optionName, args) => {
    let value = checked ? 1 : 0
    let newViewStructure = cloneDeep(args.viewStructure);
    newViewStructure.options[`${optionName}`] = value;

    args.setViewStructure(newViewStructure);
};

export const handleChangeSearchMethod = (e, argsCommon) => {
    let newMethod = e.target.value;
    if (!newMethod) return;

    let newViewStructure = cloneDeep(argsCommon.viewStructure);
    if (newViewStructure.options.method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR) {
        newViewStructure.options['sort'] = argsCommon.optionsSort;
    }
    newViewStructure.options.method = newMethod;
    if (newMethod === Constant.SETTING_SEARCH_KEYWORD.SIMILAR) {
        argsCommon.setOptionsSort(newViewStructure.options['sort']);
        newViewStructure.options['sort'] = Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.SIMILAR;
    }
    argsCommon.setViewStructure(newViewStructure);
}

export const processDrillDownDataTicketType = (viewStructure, key, value) => {
    let optionsList = [];
    let child = [];
    let noticeTypeList = [];
    let qaTypeList = [];
    let delegateTypeList = [];
    let invitationTypeList = [];
    let taskTypeList = [];
    let emailTypeList = [];
    let telephoneTypeList = [];

    let newValue = {};
    Object.values(value).forEach(item => {
        if (item.data?.name?.jp?.text) {
            if (!newValue[item.data.name.jp.text]) {
                newValue[item.data.name.jp.text] = {
                    count: 0,
                    data: []
                };
            }
            newValue[item.data.name.jp.text].count += item.count;
            newValue[item.data.name.jp.text].data = item.data;
        }
    });
    newValue.total = value?.total;

    for (const [keyChild, valueChild] of Object.entries(newValue)) {
        if (keyChild && keyChild !== 'total' && keyChild !== Constant.ORDER_IN_LIST_FIELD_KEY) {
            let childLabel = getChildNameInDrillDown(key, valueChild.data);

            let childData = {
                id: keyChild,
                label: childLabel,
                total: valueChild.count,
                createdAt: valueChild?.data?.createdAt
            };

            switch (keyChild) {
                case Constant.DRILLDOWN_TICKET_TYPE.NOTICE:
                    noticeTypeList.push(childData)
                    break;
                case Constant.DRILLDOWN_TICKET_TYPE.QA:
                    qaTypeList.push(childData)
                    break;
                case Constant.DRILLDOWN_TICKET_TYPE.DELEGATE:
                    delegateTypeList.push(childData)
                    break;
                case Constant.DRILLDOWN_TICKET_TYPE.INVITATION:
                    invitationTypeList.push(childData)
                    break;
                case Constant.DRILLDOWN_TICKET_TYPE.TASK:
                    taskTypeList.push(childData)
                    break;
                case Constant.DRILLDOWN_TICKET_TYPE.EMAIL:
                    emailTypeList.push(childData)
                    break;
                case Constant.DRILLDOWN_TICKET_TYPE.TELEPHONE:
                    telephoneTypeList.push(childData)
                    break;
                default:
                    break;
            }

            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };
            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild.count) {
                    ticketCount = `(${valueChild.count})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${childLabel}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${childLabel}`
                });
            }
        }
    }
    
    child = noticeTypeList.concat(qaTypeList, delegateTypeList, invitationTypeList, taskTypeList, emailTypeList, telephoneTypeList);
    return { child, optionsList };
};
